module.exports = __webpack_public_path__ + "static/media/img23.b7cd571a.jpg";